import React, {Component} from 'react'
import {connect} from 'react-redux'
import {appSelectors} from '@/store'
import type {Language} from '@/types'

import './index.css'

type Props = {
  l: Language,
  name: string,
  isAllowed: boolean,
  update: (number, string, boolean) => void,
  userId: number,
  disable?: boolean,
}

const getClassNameForToggleBox = (props) => {
  const {isAllowed, disable} = props
  let className = isAllowed ? 'btn btn-success' : 'btn btn-default'
  if (disable) {
    className += ' disabled'
  }
  return className
}

export class RawPermissionBox extends Component<Props> {
  togglePermission = (e: any) => {
    this.props.update(this.props.userId, this.props.name, e.currentTarget.checked)
  }

  render = () =>
    <label className={getClassNameForToggleBox(this.props)}>
      <input type="checkbox" name="options" checked={this.props.isAllowed}
        onChange={this.togglePermission} /> {this.props.l(this.props.name)}
    </label>
}

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
)(RawPermissionBox)



// WEBPACK FOOTER //
// ./src/views/forms/share-portfolio/permission-box.js